import { isValidPythonVariable } from '@polyai/common/lib/stringHelper';
import type { Variable } from '@polyai/stream/store/reducers/variables/types';

export const validateVariableName = (
  name: string,
  variables: Variable[] | undefined,
  excludeVariableId?: string,
): true | string => {
  if (!name.trim()) {
    return 'Variable name is required';
  }
  if (!isValidPythonVariable(name)) {
    return 'Variable name should be a valid Python variable';
  }
  if (
    variables?.some(
      variable => variable.name === name && variable.id !== excludeVariableId,
    )
  ) {
    return 'Sorry that name already exists';
  }
  return true;
};
